import React from 'react';

/* A clock that ticks once a minute, as an ISO string, for anything that
 * compares content against "now" while it stays on screen — the Views
 * widget's past/active row marking, for instance, which has to move rows from
 * future to active to past without a reload.
 *
 * resetKey re-stamps the clock immediately whenever it changes, without
 * disturbing the interval: pass the moment the data was last (re)loaded, so a
 * refresh marks its rows against the time of that refresh rather than against
 * a tick up to a minute old. */
const useMinuteClock = (resetKey?: string | null): string => {
  const [now, setNow] = React.useState(() => new Date().toISOString());
  const isMounting = React.useRef(true);

  React.useEffect(() => {
    const timer = window.setInterval(
      () => setNow(new Date().toISOString()),
      60 * 1000
    );
    return () => window.clearInterval(timer);
  }, []);

  React.useEffect(() => {
    /* The initial value was already stamped by useState */
    if (isMounting.current) {
      isMounting.current = false;
      return;
    }
    setNow(new Date().toISOString());
  }, [resetKey]);

  return now;
};

export default useMinuteClock;
